import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { ProductOffering } from 'anchor-shared/lib/model/entity/productOffering';

@Component({
  selector: 'app-product-discount',
  templateUrl: 'product-discount.component.html',
  styleUrls: ['product-discount.component.scss'],
})
export class ProductDiscountComponent implements OnInit {
  discountAmount: string;
  discountForm: FormGroup;

  @Input() productOffering: BehaviorSubject<Partial<ProductOffering>>;

  constructor(private _fb: FormBuilder) {}

  ngOnInit() {
    if (this.productOffering.value && this.productOffering.value.discount) {
      this.discountAmount = this.productOffering.value.discount.toString();
    } else {
      this.productOffering.value.discount = 0;
    }
    this.discountForm = new FormGroup({
      discountPrice: new FormControl('', [Validators.required]),
    });
  }

  applyDiscount() {
    if (!this.productOffering.value.discount) {
      this.productOffering.value.discount = 0;
    }

    this.productOffering.next({
      ...this.productOffering.value,
      discount: Number(this.discountAmount),
    });
  }
}
